export default "__VITE_ASSET__C8aSW29Q__"